module.exports = __webpack_public_path__ + "static/media/shift-schedule.57ad87c2.png";